import session from '@/shared/session'

const initialState = () => ({
	patient: {
		vaccinations: [],
	}
})

const state = initialState()

// getters
const getters = {
	getPatientVaccinations: (state) => () => {
		return state.patient.vaccinations
	}
}

// actions
const actions = {
	resetState ({ commit }) {
		commit('reset_state')
	},

	async getVaccinationsForCurrentPatient({ commit, state, rootState }) {
		if (!rootState.patients.current) {
			return
		}
	
		const vaccinations  = await session
			.get(`/api/patients/${rootState.patients.current?.id}/vaccinations/`)

		commit("set_vaccinations", vaccinations.data)

		return state.patient.vaccinations
	},

	createVaccination({ dispatch, commit, rootState }, data) {
		dispatch("loading/load", "vaccinations", { root: true })
		return session
				.post(`/api/vaccinations/`, {...data, decursus: rootState.decursus.current?.id})
				.then(() => {
					return dispatch("getVaccinationsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "vaccinations", { root: true })
	      })
	},

	createPatientAdminVaccination({ dispatch, commit, rootState }, data) {
		dispatch("loading/load", "vaccinations", { root: true })
		return session
				.post(`/api/patients/administration/${rootState.patients.current?.id}/vaccinations/`, data)
				.then(() => {
					return dispatch("getVaccinationsForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "vaccinations", { root: true })
	      })
	},

	deleteVaccination({ dispatch, commit }, id) {
		dispatch("loading/load", "vaccinations", { root: true })
		return session
				.delete(`/api/vaccinations/${id}/`)
				.then(() => {
					return dispatch("getVaccinationsForCurrentPatient")
				})
      .finally(() => {
        dispatch("loading/end", "vaccinations", { root: true })
      })
	}
}

// mutations
const mutations = {
  reset_state(state) {
		Object.assign(state, initialState())
  },

	set_vaccinations(state, vaccinations) {
		state.patient.vaccinations = vaccinations
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}